/* P0 kurv → checkout, sep. 2026. Hjelperen bor i cart.js, som lastes først.
   Definisjonen her er en sikring hvis lastrekkefølgen noen gang endres, siden
   hele poenget med endringen er at kunden aldri skal stå uten vei videre. */
if (typeof window.gåTilKurvsiden !== 'function') {
  window.gåTilKurvsiden = function () {
    var url = (window.routes && window.routes.cart_url) || '/cart';
    if (window.location.pathname.replace(/\/$/, '') === url.replace(/\/$/, '')) return false;
    window.location.href = url;
    return true;
  };
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close(),
    );
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.updatePaymentIconsIds();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    const åpne = (event) => {
      // Kan skuffen ikke vises (stilarket kom aldri, eller markupen er borte),
      // lar vi lenken gjøre jobben sin og gå til /cart. Uten dette ble kunden
      // stående med varer i kurven og ingen vei til checkout i det hele tatt.
      if (!this.kanVises()) return;
      event.preventDefault();
      this.open(cartLink);
    };
    cartLink.addEventListener('click', åpne);
    cartLink.addEventListener('keydown', (event) => {
      if (event.code && event.code.toUpperCase() === 'SPACE') åpne(event);
    });
  }

  /**
   * Er skuffen i stand til å vise seg?
   *
   * Leser den LUKKEDE tilstanden og rører ingen klasser. Første forsøk skrudde
   * 'active' av og på for å måle, men det kolliderte med skuffens egen
   * visibility-transisjon: rett etter en lukking rakk ikke stilen å bli
   * 'visible' igjen før vi leste den, og kurvikonet navigerte til /cart i
   * stedet for å åpne skuffen. Fanget i forhåndsvisningstesten på mobil.
   *
   * Det vi egentlig vil vite er om skuffens stilark kom fram. Uten det står
   * .drawer igjen med display:none fra inline-regelen i snippeten, og
   * .drawer.active setter bare visibility, ikke display. position:fixed
   * kommer også bare fra stilarket. Begge deler leses trygt når skuffen er
   * lukket, uten å røre noe.
   */
  kanVises() {
    if (!this.querySelector('.drawer__inner')) return false;
    const stil = window.getComputedStyle(this);
    if (stil.display === 'none') return false;
    if (stil.position !== 'fixed') return false;
    return true;
  }

  open(triggeredBy) {
    // Feilet siste kurvendring, vet vi ikke om innholdet her stemmer. Da er det
    // bedre å sende kunden til kurvsiden, som serveren alltid rendrer riktig,
    // enn å vise et bilde vi ikke kan stå inne for.
    if (this.hasAttribute('data-kurv-usikker')) {
      this.removeAttribute('data-kurv-usikker');
      if (gåTilKurvsiden()) return;
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    const productPopup = document.querySelector('product-popup');
    if (productPopup && productPopup.hasAttribute('open')) {
      productPopup.hide();
    }

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      {once: true},
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open'),
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    let skuffOppdatert = false;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (sectionElement == null) return;
      const nyHtml = this.getSectionInnerHTML(
        (parsedState.sections || {})[section.id],
        section.selector,
      );
      // Manglet seksjonen, la det gamle stå og gå videre til neste. Før kastet
      // dette, og resten av seksjonene ble aldri oppdatert.
      if (nyHtml === null) return;
      sectionElement.innerHTML = nyHtml;
      if (section.id === 'cart-drawer') skuffOppdatert = true;
    });

    // VIKTIG: /cart/add.js returnerer den tillagte varelinjen og seksjonene,
    // men IKKE item_count. Kun /cart/change og /cart/update gjør det. En
    // sjekk på `parsedState.item_count > 0` ville derfor aldri slått til på
    // legg-i-kurv-veien, som er nettopp den veien Rotårsak B går. Fanget i
    // forhåndsvisningstesten mot den ekte butikken, ikke i riggen, fordi
    // riggen den gang fabrikerte feltet.
    // renderContents kalles kun ETTER et vellykket tillegg, så er antallet
    // ukjent, vet vi likevel at kurven har minst én vare.
    const antallKjent = typeof parsedState.item_count === 'number';
    const kurvenHarVarer = antallKjent ? parsedState.item_count > 0 : true;

    // Kurven har varer, men skuffen kunne ikke rendres, ELLER den ble rendret
    // som tom. Da er kurvsiden den eneste ærlige veien videre; å vise en tom
    // skuff over en kurv med varer sier kunden noe usant, og lar dem ikke
    // komme til checkout.
    if (kurvenHarVarer && (!skuffOppdatert || this.viserTomKurv())) {
      gåTilKurvsiden();
      return;
    }

    // Serveren har svart, så nå vet vi nok til å sette tomtilstanden.
    this.settTomtilstand(antallKjent ? parsedState.item_count === 0 : false);
    this.removeAttribute('data-kurv-usikker');

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  /**
   * ROTÅRSAK B, sep. 2026. Tomtilstanden bodde i to klasser som kunne sprike:
   * `is-empty` på <cart-drawer> og på <cart-drawer-items>. To CSS-regler leser
   * dem hver for seg:
   *   cart-drawer-items.is-empty + .drawer__footer { display: none }
   *   cart-drawer:not(.is-empty) .cart-drawer__warnings { display: none }
   * Sto den ene på og den andre av, forsvant BÅDE checkout-knappen OG
   * «kurven er tom»-teksten samtidig, og kunden satt igjen med en skuff som
   * bare viste overskriften. Derfor settes de nå alltid sammen, fra ett sted.
   */
  settTomtilstand(tom) {
    this.classList.toggle('is-empty', Boolean(tom));
    const varer = this.querySelector('cart-drawer-items');
    if (varer) varer.classList.toggle('is-empty', Boolean(tom));
  }

  /** Viser skuffen tomtilstand akkurat nå? */
  viserTomKurv() {
    const varer = this.querySelector('cart-drawer-items');
    if (varer && varer.classList.contains('is-empty')) return true;
    if (this.querySelector('.drawer__inner-empty')) return true;
    return this.querySelectorAll('.cart-item').length === 0;
  }

  /** Null i stedet for TypeError når seksjonen mangler i svaret. */
  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (typeof html !== 'string' || html.length === 0) return null;
    const node = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return node ? node.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'product-free-shipping',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updatePaymentIconsIds() {
    const paymentIcons = this.querySelectorAll('.js-payment-icon');
    if (paymentIcons.length < 1) return;
    paymentIcons.forEach((icon) => {
      const id = icon.getAttribute('aria-labelledby');
      icon.setAttribute('aria-labelledby', 'cart-drawer-' + id);
      icon.querySelector('title').id = 'cart-drawer-' + id;
    });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
        // Bærer varelinjene, totalen og checkout-knappen.
        bærerKurven: true,
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'product-free-shipping',
        section: 'product-free-shipping',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
